<div class="footer">
  <div class="footer__row">
    <h5>Write on <a class="mail" href="mailTo:medpad007@gmail.com" target="_blank">medpad007@gmail.com</a></h5>
    <button mat-button (click)="openFeedbackDialog()" class="mp-typo--small-bold"><b><u>Feedback</u></b></button>
  </div>
  <hr>
  <div class="footer__row">
    <h5>Contact on: 7565053977, 9919787471</h5>
    <p class="mp-typo--small-bold"><img src="./assets/images/handshake.png" alt="handshake">Made with love by Team Conatus</p>
  </div>
</div>
